import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import NovoOrcamento from './pages/NovoOrcamento';
import MeusPedidos from './pages/MeusPedidos';
import Rascunhos from './pages/Rascunhos';
import PedidoDetalhe from './pages/PedidoDetalhe';
import Usuarios from './pages/Usuarios';
import Perfis from './pages/Perfis';

// Duas situações diferentes caem aqui, e confundi-las manda a pessoa para o
// lugar errado:
//   · SEM PERFIL NENHUM  -> ninguém configurou o acesso dela ainda. É a TI/gestor.
//   · COM PERFIL, sem ESTA permissão -> o acesso existe, só não cobre esta tela.
function SemPermissao({ usuario }) {
  const semPerfil = !usuario.perfil_id;
  return (
    <div className="card" style={{ maxWidth: 560, margin: '6vh auto' }}>
      <div className="card-body text-center p-4">
        <div className="d-inline-flex align-items-center justify-content-center mb-3"
             style={{ width: 58, height: 58, borderRadius: 16,
                      background: '#fef3c7', color: '#92400e', fontSize: '1.6rem' }}>
          <i className={`bi ${semPerfil ? 'bi-person-x' : 'bi-shield-lock'}`} />
        </div>
        <h2 className="h5 fw-bold mb-2">
          {semPerfil ? 'Seu acesso ainda não foi configurado' : 'Esta tela não faz parte do seu acesso'}
        </h2>
        <p className="text-muted small mb-3">
          {semPerfil
            ? <>Você entrou como <strong>{usuario.username}</strong>, mas ainda não tem um perfil
                atribuído no Fênix. Peça à TI para liberar — é rápido.</>
            : <>Seu perfil é <strong>{usuario.perfil_nome}</strong>, que não inclui esta tela.
                Se você precisa dela, peça ao gestor.</>}
        </p>
        <p className="text-muted mb-0" style={{ fontSize: '.78rem' }}>
          <i className="bi bi-arrow-left me-1" />
          Use o menu ao lado para ir a outra tela.
        </p>
      </div>
    </div>
  );
}

function RotaPrivada({ children, permissao }) {
  const { usuario, carregando, temPermissao } = useAuth();

  if (carregando) {
    return (
      <div className="d-flex align-items-center justify-content-center vh-100">
        <span className="spinner-border" style={{ color: 'var(--primary)' }} />
      </div>
    );
  }
  if (!usuario) return <Navigate to="/login" replace />;

  // ⚠️ O aviso de "sem permissão" vai DENTRO do layout, com a sidebar.
  //    Antes ele substituía a tela inteira: quem caísse aqui ficava preso numa
  //    página em branco, sem menu e sem nem conseguir sair. Perder o acesso a
  //    uma tela não pode significar perder o acesso ao sistema.
  const conteudo = permissao && !temPermissao(...[].concat(permissao))
    ? <SemPermissao usuario={usuario} />
    : children;

  return (
    <div className="layout">
      <Sidebar />
      <main className="main-content">{conteudo}</main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/orcamento" element={
            <RotaPrivada permissao="pedidos_criar"><NovoOrcamento /></RotaPrivada>
          } />
          <Route path="/rascunhos" element={
            <RotaPrivada permissao="pedidos_criar"><Rascunhos /></RotaPrivada>
          } />
          <Route path="/pedidos" element={
            <RotaPrivada permissao={['pedidos_ver_proprios', 'pedidos_ver_todos']}><MeusPedidos /></RotaPrivada>
          } />
          <Route path="/pedidos/:uuid" element={
            <RotaPrivada permissao={['pedidos_ver_proprios', 'pedidos_ver_todos']}><PedidoDetalhe /></RotaPrivada>
          } />
          <Route path="/admin/usuarios" element={
            <RotaPrivada permissao="admin_usuarios"><Usuarios /></RotaPrivada>
          } />
          <Route path="/admin/perfis" element={
            <RotaPrivada permissao="admin_perfis"><Perfis /></RotaPrivada>
          } />
          <Route path="*" element={<Navigate to="/orcamento" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
